import React from 'react';
import ReactGA from 'react-ga';

export default () => (
  <div className="Home">
    <div className="title">
      Welcome!
    </div>
    <div className="content">
      I have a PhD in International Relations from the&nbsp;
      <ReactGA.OutboundLink
        eventLabel="Ekohist Link"
        to="http://www.ekohist.su.se"
        target="_blank"
      >
        Department of Economic History
      </ReactGA.OutboundLink>
      &nbsp;at Stockholm University. I was also a part of the&nbsp;
      <ReactGA.OutboundLink
        eventLabel="Mistra Link"
        to="http://www.mistra-geopolitics.se"
        target="_blank"
      >
        Mistra Geopolitics
      </ReactGA.OutboundLink>
      &nbsp;project.
    </div>
    <div className="content">
      Previously, I completed my MSc program in Political Science at the&nbsp;
      <ReactGA.OutboundLink
        eventLabel="Statsvet Link"
        to="http://www.statsvet.uu.se"
        target="_blank"
      >
        Department of Government
      </ReactGA.OutboundLink>
      , Uppsala University.
    </div>
    <div className="content">
      My research interests lie in the intersection of environmental politics and global governance.
      I am particularly interested in finding novel ways in measuring and evaluating social
      legitimacy and effectiveness of the global governance responses. How global governance
      institutions cope with climate induced environmental change and the related security risks
      is the current focus of my dissertation project.
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/home/View.js